// client/src/components/ui/Notification.jsx

import React, { useState, useEffect } from 'react';
import './Notification.css';

const Notification = ({ 
  message, 
  type = 'info', 
  duration = 3000,
  onClose,
  isVisible = true
}) => {
  const [visible, setVisible] = useState(isVisible);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setVisible(false);
        
        // Attendre que l'animation de sortie se termine avant d'appeler onClose
        setTimeout(() => {
          if (onClose) onClose();
        }, 300);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  // Gérer la fermeture manuelle
  const handleClose = () => {
    setVisible(false);
    
    // Attendre que l'animation de sortie se termine
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  };

  // Obtenir l'icône en fonction du type
  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✗';
      case 'warning':
        return '⚠';
      case 'info':
      default:
        return 'ℹ';
    }
  };

  return (
    <div className={`notification ${type} ${visible ? 'visible' : 'hidden'}`}>
      <div className="notification-content">
        <div className="notification-icon">{getIcon()}</div>
        <span className="notification-message">{message}</span>
        <button className="notification-close" onClick={handleClose}>
          &times;
        </button>
      </div>
    </div>
  );
};

export default Notification;